export default "__VITE_ASSET__DRzrNT$F__"